export default __webpack_public_path__ + "static/media/home-7.f08dcd85.jpg";